(function () {
    'use strict';

    angular
        .module('services.selectionService', [])
        .factory('selectionService', service);

    service.$inject = ['modalService'];

    function service(modalService) {
        return {

            init: function (labelSingular, labelPlural, createGroupFn, createGroupCb, compatibleGroupsFn, addToGroupFn, addToGroupCb) {
                return {
                    itemSelectionChanged: function (item, isSelected) {
                        if (isSelected) {
                            this.selectionMode = true;
                            this.selectedItems.push(item.CACMEventID);
                            this.selectedItemsObjects.push(item);
                        } else {
                            var idx = this.selectedItems.indexOf(item.CACMEventID);
                            this.selectedItems.splice(idx, 1);
                            this.selectedItemsObjects.splice(idx, 1);
                            if (this.selectedItems.length === 0) {
                                this.selectionMode = false;
                            }
                        }
                    },

                    cancelSelection: function () {
                        this.selectedItems.splice(0, this.selectedItems.length);
                        this.selectedItemsObjects.splice(0, this.selectedItemsObjects.length);
                        this.selectionMode = false;
                    },

                    createGroup: function () {
                        modalService.displayFormModal(
                            // Title
                            'Please provide a name for the group',

                            // Content Config
                            [{ key: 'message', label: 'Name', type: modalService.types.TEXT, required: true }],

                            // Success Callback
                            angular.bind(this, function (values) {
                                if (_.isFunction(createGroupCb)) {
                                    // Create the group
                                    createGroupFn.call(null, values.message, this.selectedItems)
                                        .then(angular.bind(this, function (res) {
                                            // Call the success callback and cancel selection
                                            if (_.isFunction(createGroupCb)) {
                                                this.cancelSelection();
                                                createGroupCb.call(null, res);
                                            }
                                        }));
                                } else {
                                    this.cancelSelection();
                                }
                            }),

                            // Allow Cancel
                            true
                        );
                    },

                    addToGroup: function () {
                        this._loadingCompatibleGroups = true;
                        compatibleGroupsFn.call(null, this.selectedItems)
                            .then(angular.bind(this, function (compatibleGroups) {
                                this._loadingCompatibleGroups = false;
                                var modal = modalService.displayTemplateModal(
                                    // Title
                                    'Please select a group',

                                    // Template URL
                                    require('../../cacm/event/FindCACMEventGroup.tpl.html'),

                                    // Scope content
                                    {
                                        results: compatibleGroups,

                                        // Called when user selects a group
                                        onSelect: angular.bind(this, function (selectedGroup) {
                                            addToGroupFn.call(null, selectedGroup, this.selectedItems)
                                                .then(angular.bind(this, function (group) {
                                                    if (_.isFunction(addToGroupCb)) {
                                                        this.cancelSelection();
                                                        addToGroupCb.call(null, group);
                                                    }
                                                }));
                                            modal.$promise.then(modal.hide);
                                        })
                                    },

                                    // Success callback
                                    null,

                                    // Allow cancel
                                    false
                                )
                            }));
                    },

                    _loadingCompatibleGroups: false,

                    labelSingular: labelSingular,

                    labelPlural: labelPlural,

                    selectionMode: false,

                    selectedItems: [],

                    selectedItemsObjects: [],

                    actionsType: 'cacmGrouping'
                }
            }
        }
    }
})();
